import CrudCustom from '../../../libs/custom/CrudCustom';

let PajakTerutangSandingService = new CrudCustom('/transaksi-sandings');
export default PajakTerutangSandingService;

